<template>
    <div v-if="isLoaded">
        <competences-elements
            v-for="element in elements"
            :key="element.id"
            :elements="element.elements"
            :id="element.id"
            :title="element.name" />
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import CompetencesElements from '../components/competences/competencesElements'

export default {
    name: 'competences',
    components: {
        CompetencesElements
    },
    mounted () {
        this.$nextTick(() => {
            this.load()
        })
    },
    computed: {
        ...mapGetters({
            languages: 'competencesModule/getLanguages',
            frameworks: 'competencesModule/getFrameworks',
            databases: 'competencesModule/getDatabases',
            libraries: 'competencesModule/getLibraries',
            apis: 'competencesModule/getApis',
            tools: 'competencesModule/getTools',
            locales: 'competencesModule/getLocales',
            isLoaded: 'competencesModule/isLoaded'
        }),
        elements () {
            return [
                {id: 'languages', name: 'Langages', elements: this.languages},
                {id: 'frameworks', name: 'Frameworks', elements: this.frameworks},
                {id: 'databases', name: 'Bases de données', elements: this.databases},
                {id: 'libraries', name: 'Librairies', elements: this.libraries},
                {id: 'apis', name: 'API', elements: this.apis},
                {id: 'tools', name: 'Outils', elements: this.tools},
                {id: 'locales', name: 'Langues', elements: this.locales}
            ]
        }
    },
    methods: {
        ...mapActions({
            load: 'competencesModule/loadCompetences'
        })
    }
}
</script>

<style scoped lang="scss">
 div {
    width: calc(100% - 58px) !important;
    margin: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/competences.vue